export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
export const SET_DEFAULT_FILTER = "SET_DEFAULT_FILTER";
